import { FormattedMessage } from 'react-intl';

// Components
import SetupGridItem from '../../SetupGridItem';
import { SetupValue } from '../Programs/shared';

// Constants
import { MINNESOTA_STATE_CODE, MN_HOUSING_D_NUMBER_KEY } from '../../constants';
import messages from './messages';

// Types
import type { PropertyStateConfigValues } from '../../types';

// Ties the visible label to the input, so the field is announced by its label.
const INPUT_ID = 'mn-housing-d-number';

type Props = {
  editMode: boolean,
  onChange: Function,
} & PropertyStateConfigValues;

// The Minnesota Housing D Number identifies the property itself in Minnesota Housing reporting,
// whatever its programs are, so it is shown once for every Minnesota property and saved as a
// property-wide state config (no program filter). Rendered as a grid item: the caller places it
// in a Grid container.
function MNHousingDNumber({
  editMode,
  onChange,
  state,
  stateConfigs = [],
}: Props) {
  if (state !== MINNESOTA_STATE_CODE) {
    return null;
  }

  const dNumber = stateConfigs.find(
    (stateConfig) => stateConfig.key === MN_HOUSING_D_NUMBER_KEY,
  );

  const handleChange = (evt) => {
    const value = evt.target.value || null; // Prefer null over empty string
    const updatedStateConfigs = dNumber
      ? stateConfigs.map((stateConfig) =>
          stateConfig === dNumber ? { ...stateConfig, value } : stateConfig,
        )
      : [
          ...stateConfigs,
          {
            key: MN_HOUSING_D_NUMBER_KEY,
            value,
            affordableProgramFilter: null,
          },
        ];

    onChange({ target: { name: 'stateConfigs', value: updatedStateConfigs } });
  };

  return (
    <SetupGridItem
      label={<FormattedMessage {...messages.label} />}
      htmlFor={editMode ? INPUT_ID : undefined}
      TooltipProps={{ title: <FormattedMessage {...messages.tooltip} /> }}
    >
      <SetupValue
        editMode={editMode}
        id={INPUT_ID}
        name={MN_HOUSING_D_NUMBER_KEY}
        value={dNumber?.value ?? ''}
        onChange={handleChange}
        placeholder="i.e. D1234"
      />
    </SetupGridItem>
  );
}

export default MNHousingDNumber;
